var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"id":"project-overview","fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('idc-component-finance-wip',{attrs:{"settings":_vm.settings}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }